module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Meus dados")])], 1)]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "index.html",
      "method": "post",
      "id": "profile-form"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row margin-t10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.user.type == 2) ? _c('div', {
    staticClass: "form-box margin-b20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Informações básicas da empresa")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.taxIdNumber),
      expression: "user.taxIdNumber"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "taxIdNumber",
      "name": "taxIdNumber",
      "title": "cnpj",
      "placeholder": "CNPJ",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user.taxIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "taxIdNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.company.companyName),
      expression: "user.company.companyName"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "title": "razão social",
      "placeholder": "Razão social",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user.company.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.company, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-b10"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.company.companyTradeName),
      expression: "user.company.companyTradeName"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "title": "razão social",
      "placeholder": "Nome fantasia",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user.company.companyTradeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.company, "companyTradeName", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.user.type == 1) ? _c('div', {
    staticClass: "form-box margin-b20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Informações básicas")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.taxIdNumber),
      expression: "user.taxIdNumber"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "taxIdNumber",
      "name": "taxIdNumber",
      "title": "cpf",
      "placeholder": "CPF",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user.taxIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "taxIdNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "title": "nome",
      "placeholder": "Nome Completo",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.person.name + ' ' + _vm.user.person.lastName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-b10"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "title": "data de nascimento",
      "placeholder": "Data de nascimento",
      "readonly": ""
    },
    domProps: {
      "value": _vm._f("date")(_vm.user.person.birthDate)
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box margin-b30"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Contatos")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control margin-b10",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email2),
      expression: "user.email2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "title": "email",
      "placeholder": "E-mail",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user.email2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control"
  }, [_c('div', {
    staticClass: "label-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box margin-t10"
  }, [(_vm.is2faValid) ? _c('div', [_c('button', {
    staticClass: "btn btn-default margin-t10",
    attrs: {
      "id": "btn-confirm-recharge",
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeEmail()
      }
    }
  }, [_c('span', {
    staticClass: "text-btn-recharge"
  }, [_vm._v("Alterar e-mail")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control margin-b10",
    class: {
      'has-error': _vm.errors.has('celular')
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cel),
      expression: "cel"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "celular",
      "name": "celular",
      "title": "celular",
      "placeholder": "Celular",
      "disabled": _vm.isCampoDesabilitado
    },
    domProps: {
      "value": (_vm.cel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cel = $event.target.value
      }, _vm.correctCursor]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("celular")) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control"
  }, [_c('div', {
    staticClass: "label-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box margin-t10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowSMS),
      expression: "allowSMS"
    }],
    staticClass: "check-terms",
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allowSMS) ? _vm._i(_vm.allowSMS, null) > -1 : (_vm.allowSMS)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allowSMS,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allowSMS = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allowSMS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allowSMS = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Deseja Receber SMS ?")]), _vm._v(" "), (_vm.is2faValid) ? _c('div', [_c('button', {
    staticClass: "btn btn-default margin-t10",
    attrs: {
      "id": "btn-confirm-recharge",
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePhone()
      }
    }
  }, [_c('span', {
    staticClass: "text-btn-recharge"
  }, [_vm._v("Alterar celular")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('telefone')
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "telefone",
      "name": "telefone",
      "title": "telefone",
      "placeholder": "Telefone",
      "disabled": _vm.isTelDisable
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }, _vm.correctCursor]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("telefone")) + "\n                ")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CNPJ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Razão social")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome fantasia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CPF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome Completo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Data de nascimento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Celular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Telefone")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-97a25e88!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/profile/user.vue
// module id = 2193
// module chunks = 1